/* Homepage SKU grid — fires the `home_quick_add` analytics event when one of
   this section's cards is added to cart.
   Cart add + drawer open are NOT handled here: the <product-form> markup in
   sections/homepage-sku-grid.liquid uses the theme's existing product-form.js
   custom element, which already posts to /cart/add and opens cart-drawer.js.
   This file only listens on the same PUB_SUB_EVENTS.cartUpdate bus that
   product-form.js already publishes to (see assets/cart.js for the other
   subscriber), matching a variant id back to one of this section's cards. */
(function () {
  function init(section) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (typeof section.__skuGridUnsub === 'function') section.__skuGridUnsub();

    var cards = {};
    section.querySelectorAll('.homepage-sku-grid__card').forEach(function (card) {
      var input = card.querySelector('.product-variant-id');
      if (!input || !input.value) return;
      cards[String(input.value)] = card;
    });

    section.__skuGridUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var card = cards[String(event.productVariantId)];
      if (!card) return;
      if (!window.ChillabAnalytics || typeof window.ChillabAnalytics.track !== 'function') return;

      var cartData = event.cartData || {};
      var priceCents = typeof cartData.price === 'number' ? cartData.price : null;

      window.ChillabAnalytics.track('chillab_home_quick_add', {
        product_id: cartData.product_id || card.getAttribute('data-product-id') || '',
        product_handle: cartData.handle || card.getAttribute('data-product-handle') || '',
        product_title: cartData.product_title || '',
        variant_id: cartData.id || cartData.variant_id || event.productVariantId || '',
        price: priceCents !== null ? priceCents / 100 : '',
        quantity: cartData.quantity || 1,
        source: 'homepage_sku_grid',
      });
    });
  }

  /* Progress bar. track (the real, actual scrolling element — the same
     <ul id="Slider-..."> that overflow-x: auto lives on, that Dawn's
     <slider-component> scrolls via scrollTo(), and that the drag-scroll
     handler below sets .scrollLeft on directly, so all three ways of
     moving this carousel — arrow click, drag, native touch/trackpad —
     funnel through the exact same element's scrollLeft) is passed in
     from initCarousel, which resolves it as
     slider.querySelector('[id^="Slider-"]').

     Fenty-style fixed-width thumb, not a growing fill: width is the
     visible-vs-scrollable ratio (clientWidth / scrollWidth), position is
     a translateX offset — left stays 0 in CSS so the transform is the
     only thing that moves the thumb.

     A single sync() writes both, called from scroll/resize/load and from
     a ResizeObserver on the track. No requestAnimationFrame and no
     self-rescheduling loop: nothing runs while the carousel sits still,
     and the thumb can't desync from a scroll position that rAF never got
     a frame to react to. */
  function initProgressBar(section, track) {
    var progressContainer = section.querySelector('[data-homepage-sku-grid-progress]');
    var progressBar = section.querySelector('[data-homepage-sku-grid-progress-thumb]');
    if (!progressContainer || !progressBar) return;

    var slideCount = track.querySelectorAll('[id^="Slide-"]').length;
    if (slideCount < 2) {
      progressContainer.hidden = true;
      return;
    }
    progressContainer.hidden = false;

    var lastWidthPct = null;

    /* One function for both width and offset. Every layout read
       (scrollWidth/clientWidth/scrollLeft on the track, clientWidth on the
       container) happens before the first style write, so this never
       triggers a read-after-write forced reflow — the previous version read
       progressBar.offsetWidth immediately after setting its width, which did.
       travel is derived from the same ratio as the width instead of a
       separate offsetWidth measurement, so the thumb's right edge lands
       exactly on the track's right edge at full scroll by construction. */
    function sync() {
      var scrollWidth = track.scrollWidth;
      var clientWidth = track.clientWidth;
      var containerWidth = progressContainer.clientWidth;
      var scrollLeft = track.scrollLeft;

      var ratio = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
      var widthPct = ratio * 100;
      if (widthPct !== lastWidthPct) {
        lastWidthPct = widthPct;
        progressBar.style.width = widthPct + '%';
      }

      var maxScroll = scrollWidth - clientWidth;
      var travel = containerWidth * (1 - ratio);
      var x = maxScroll <= 0 ? 0 : (scrollLeft / maxScroll) * travel;
      progressBar.style.transform = 'translateX(' + x + 'px)';
    }

    sync();

    if (!track.__skuGridProgressBound) {
      track.__skuGridProgressBound = true;

      /* The transform is written straight from the scroll handler rather
         than deferred into a requestAnimationFrame callback. rAF was the
         thumb's only update path, and it is a single point of failure: any
         state that starves rAF (a backgrounded/unpainted tab, a long task)
         leaves the thumb frozen at translateX(0) while the carousel keeps
         scrolling — reproduced exactly that way, scrollLeft at its maximum
         with the thumb still at 0. A transform write is compositor-only and
         the width write is skipped unless the ratio actually changed, so
         running per scroll event costs less than the coalescing did. */
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      /* Late layout still moves scrollWidth after init: lazy card images
         resolving, the DM Sans swap, a Market currency change relaying the
         price line. init runs from a deferred script, before any of those.
         Without these the ratio computed once at init sticks forever — a
         wrong ratio there (all cards appearing to fit, so ratio 1) renders
         as a full-width bar with nothing to see moving. */
      window.addEventListener('load', sync);
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(sync).observe(track);
      }
    }
  }

  /* Mouse click-and-drag scrolling — desktop/mouse only. Native
     overflow-x: auto already handles touch swipe and trackpad scrolling
     on its own; a mouse has no built-in click-drag-to-scroll gesture, so
     this adds one by hand. Suppresses the product link's click if the
     user actually dragged (moved past a small threshold), so a drag
     doesn't accidentally navigate to the PDP when the mouse is released. */
  function initDragScroll(track) {
    if (track.__skuGridDragBound) return;
    track.__skuGridDragBound = true;

    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScrollLeft = 0;

    track.addEventListener('mousedown', function (evt) {
      isDown = true;
      dragged = false;
      startX = evt.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('homepage-sku-grid__list--dragging');
    });

    window.addEventListener('mousemove', function (evt) {
      if (!isDown) return;
      var delta = evt.pageX - startX;
      if (Math.abs(delta) > 5) dragged = true;
      if (dragged) evt.preventDefault();
      track.scrollLeft = startScrollLeft - delta;
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('homepage-sku-grid__list--dragging');
    });

    track.addEventListener(
      'click',
      function (evt) {
        if (!dragged) return;
        evt.preventDefault();
        evt.stopPropagation();
        dragged = false;
      },
      true
    );
  }

  /* Carousel chrome: progress bar sync, mouse drag-to-scroll, and arrow
     vertical centering. The actual sliding (smooth scrollTo, prev/next
     enable-disable at the ends, data-step paging) is Dawn's existing
     <slider-component> (assets/global.js) — reused as-is. */
  function initCarousel(section) {
    var slider = section.querySelector('slider-component');
    var track = slider && slider.querySelector('[id^="Slider-"]');
    if (!slider || !track) return;

    initProgressBar(section, track);
    initDragScroll(track);

    if (!slider.__skuGridArrowHeightBound) {
      slider.__skuGridArrowHeightBound = true;
      var firstMedia = slider.querySelector('.homepage-sku-grid__media');
      if (firstMedia) {
        var cards = Array.prototype.slice.call(slider.querySelectorAll('.homepage-sku-grid__card'));

        /* --sku-grid-image-h: one shared value (every card has the same
           column width, so the same natural square image height) used
           both for the arrow's vertical centering and, on hover-capable
           devices only (see homepage-sku-grid.css), as the card's
           default (pre-hover) image height and the text block's
           padding-top.
           --sku-grid-card-h: set per card, not shared — Dawn's grid
           stretches every card in a row/page to match its tallest
           neighbor, and different pages can land on different heights.
           This is the hover-expanded target height each card's image
           animates to, measured from the card's own actual rendered
           height so it's always exactly right, never guessed. */
        var syncArrowHeight = function () {
          /*
             Derive the square media height from its current width, not its
             rendered height. On desktop the rendered height is itself driven
             by --sku-grid-image-h; reading offsetHeight there creates a
             circular cache. Crossing from the 1.3-card mobile layout back to
             desktop used to preserve the wider mobile value forever, leaving
             a tall blank area inside every narrower desktop card.
          */
          slider.style.setProperty('--sku-grid-image-h', firstMedia.offsetWidth + 'px');
          cards.forEach(function (card) {
            card.style.setProperty('--sku-grid-card-h', card.offsetHeight + 'px');
          });
        };
        syncArrowHeight();

        var resizeTimeout;
        window.addEventListener('resize', function () {
          window.clearTimeout(resizeTimeout);
          resizeTimeout = window.setTimeout(syncArrowHeight, 100);
        });
      }
    }
  }

  /* There are 3 independent rows of this section on the homepage, each
     its own [data-section="homepage-sku-grid"] element. Without this
     try/catch, an uncaught error while wiring up one row (init or
     initCarousel throwing) aborts the whole forEach — the remaining
     rows would never get their own progress bar / drag-scroll / arrow
     sync wired up at all, even though nothing is actually wrong with
     their markup. Isolating each row's setup is what actually
     guarantees the 3 rows compute and update independently. */
  function initSection(section) {
    try {
      init(section);
      initCarousel(section);
    } catch (err) {
      if (window.console && console.error) console.error('homepage-sku-grid init failed for a row', err);
    }
  }

  document.querySelectorAll('[data-section="homepage-sku-grid"]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('[data-section="homepage-sku-grid"]');
    if (!section) return;
    initSection(section);
  });
})();
